import type { BaseOptionType } from "antd/lib/select"

import {
  isLifecycleStage,
  stageIndex
} from "../../Lead/constants/lifecycle-stages.ts"

export interface LeadStatusOptionGroup extends BaseOptionType {
  options: BaseOptionType[]
}

/**
 * `filter_options.status` arrives as one flat list in enum order, mixing the
 * seven lifecycle stages with statuses the transition service retired. Both stay
 * filterable — leads are still parked on the retired ones — but reading them as
 * one list makes a retired status look like a stage a lead can be moved to.
 *
 * The lifecycle comes first in lifecycle order (which is not enum order: Booked,
 * Exploration and Contract were added after the enum), and everything else keeps
 * the order it arrived in under one group label. Presentation only: every option
 * that came in goes out, with the same value.
 */
const groupLeadStatusOptions = (
  options: BaseOptionType[] | undefined | null,
  legacyLabel: string
): (BaseOptionType | LeadStatusOptionGroup)[] => {
  const all = options ?? []

  const lifecycle = all
    .filter((option) => isLifecycleStage(option?.value))
    .sort((a, b) => stageIndex(a?.value) - stageIndex(b?.value))

  const legacy = all.filter((option) => !isLifecycleStage(option?.value))

  return legacy.length
    ? [...lifecycle, { label: legacyLabel, title: legacyLabel, options: legacy }]
    : lifecycle
}

export { groupLeadStatusOptions }
